import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getMessaging } from 'firebase/messaging';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBbLUqwUcgskd_wfabUxb98-4Y54qC0aK4",
  authDomain: "redbus-3ec46.firebaseapp.com",
  projectId: "redbus-3ec46",
  storageBucket: "redbus-3ec46.firebasestorage.app",
  messagingSenderId: "319710447950",
  appId: "1:319710447950:web:970fea3fe3327a73a2f61f",
  measurementId: "G-4GCD8N81Z4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const database = getDatabase(app);
const messaging = getMessaging(app);

// Export initialized Firebase services
export { db, database, messaging };
